module.exports = __webpack_public_path__ + "img/splash-2.cd42bada.png";